export enum ErrorMessageBindingStrategy {
    None,
    OnSubmit,
    OnDirty,
    OnTouched,
    OnDirtyOrTouched,
    OnDirtyOrSubmit,
    OnTouchedOrSubmit
}
